import React from 'react';
// Import images
import img1 from '../../assets/images/wrestling/mistress-md-professional-dominatrix-wrestling-fetish-beating-girl.jpg';
import img2 from '../../assets/images/wrestling/mistress-md-professional-dominatrix-wrestling-fetish-beating-man.jpg';
import img3 from '../../assets/images/wrestling/mistress-md-professional-dominatrix-wrestling-fetish-leg-hold.jpg';
import img4 from '../../assets/images/wrestling/mistress-md-professional-dominatrix-wrestling-fetish-with-girl.jpg';
// Components
import MainContainerContent from '../general/MainContainerContent';
import GeneralPriceTable from '../general/GeneralPriceTable';
// Data
import { wrestlingRatesArray } from '../../utils/data/PriceData';

function WrestlingPageMainContainer() {
  return (
    <main role='main' className='grid pt-6 pb-12'>
      <MainContainerContent
        title='Wrestling Empress'
        subtitle='Experience the Action Like Never Before'
        paraOne={`A spectacle of Femdom wrestling at its finest, I am Mistress of the mats!! Using my powerful legs to scissor my opponents into submission, my strong arms to lock you into holds you can't escape from plus my strategic mind and techniques to outmaneuver you at every turn. A guaranteed, intense, adrenaline-fueled, fantasy or erotic encounter that will leave you breathless…`}
        paraTwo={`Don't just fantasize—step into the ring and experience the ultimate domination. Feel my strength, my control, and my power as I wrestle you into submission. Whether you're craving an intense struggle or an electrifying fantasy session, I am the Mistress who will take you to the edge. Book your match now and surrender to your fate beneath me.`}
        images={[img1, img2, img3, img4]}
      />

      <GeneralPriceTable
        title='Wrestling Prices'
        rates={wrestlingRatesArray}
        depositMessage='A £60 deposit (non-negotiable & non-refundable) is required to secure a booking.'
        extraMessage='Extras apply for sessions involving mess, topless, or nudity.'
      />
    </main>
  );
}

export default WrestlingPageMainContainer;
